import { useCallback } from "react";
import useU2000AxiosAuthenticated from "../u2000Core/axios/U2000UseAxiosAuthenticated";
import { doRefuse } from "./U3130Service";
import type { U3130Timesheet } from "./U3130TimesheetModel";

export function useU3130RefuseHandlers() {
  const axios = useU2000AxiosAuthenticated();

  const refuse = useCallback(
    async (timesheetId: string, version: number): Promise<U3130Timesheet> => {
      const res = await doRefuse(axios, timesheetId, { id: timesheetId, version });
      const raw = res.data?.result ?? res.data;
      return raw as U3130Timesheet;
    },
    [axios],
  );

  return { refuse };
}
